import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";

export default function PejabatStruktural() {
  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Pusat Informasi — Pejabat Struktural
          </p>
          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl">
            Pejabat Struktural
          </h1>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <div className="mt-14 grid gap-12 lg:grid-cols-[360px_1fr] lg:gap-16">
          <Reveal className="lg:sticky lg:top-24 lg:self-start">
            <figure
              data-testid="kepala-photo-card"
              className="overflow-hidden rounded-3xl border border-[#E3EBF3] bg-[#F3F7FB]"
            >
              <img
                src="/kepala-lldikti7.jpg"
                alt="Prof. Dr. Dyah Sawitri, S.E., M.M. — Kepala LLDIKTI Wilayah VII"
                data-testid="kepala-photo"
                className="w-full object-cover"
              />
              <figcaption className="border-t border-[#E3EBF3] px-5 py-4">
                <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
                  Kepala LLDIKTI Wilayah VII
                </p>
                <p className="mt-2 font-display text-xl font-medium leading-snug text-[#0B2440]">
                  Prof. Dr. Dyah Sawitri, S.E., M.M.
                </p>
              </figcaption>
            </figure>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="space-y-8 text-[15px] leading-relaxed text-slate-600 md:text-base">
              <p data-testid="struktural-text-1">
                Lembaga Layanan Pendidikan Tinggi (LLDIKTI) Wilayah VII
                dipimpin oleh seorang Kepala yang merupakan pejabat pimpinan
                tinggi pratama atau jabatan struktural eselon II.b. Dalam
                melaksanakan tugas dan fungsi, Kepala LLDIKTI Wilayah VII
                bertanggungjawab kepada Menteri, dengan pembinaan administratif
                dibawah Sekretaris Jenderal dan pembinaan teknis dibawah
                Direktur Jenderal yang terkait dengan tugas-tugas LLDIKTI
                Wilayah VII.
              </p>
              <p data-testid="struktural-text-2">
                Kepala LLDIKTI Wilayah VII saat ini dijabat oleh Prof. Dr. Dyah
                Sawitri, S.E., M.M. Beliau dilantik sebagai Kepala LLDIKTI
                Wilayah VII pada tanggal 30 Juni 2022. Kepala LLDIKTI Wilayah
                VII bertanggung jawab dalam pengelolaan dan pengembangan
                lembaga pendidikan di wilayahnya, dengan komitmen untuk
                meningkatkan kualitas pendidikan serta mendukung pengembangan
                institusi pendidikan di Indonesia, khususnya untuk meningkatkan
                mutu pendidikan tinggi di Jawa Timur.
              </p>
              <p data-testid="struktural-text-3">
                Dalam menjalankan tugasnya, Kepala LLDIKTI Wilayah VII dibantu
                oleh seorang Kepala Bagian Umum yang merupakan pejabat
                administrator (dahulu eselon III). LLDIKTI Wilayah VII juga
                membentuk Tim Kerja untuk menangani tugas-tugas yang berkaitan
                dengan pelayanan eksternal, Satuan Penanggungjawab Urusan
                untuk menangani tugas-tugas yang berkaitan dengan urusan
                internal dan pendukung layanan, serta unit-unit khusus guna
                memperkuat pelayanan dan proses bisnis seperti Tim RB/ZI, Tim
                SPI, Tim Pengelola KIPK, Tim Pengadaan Barang dan Jasa, Tim
                Hukum, Tim Humas, dan Tim PPID.
              </p>
            </div>
            <a
              href="https://lldikti7.kemdiktisaintek.go.id/profil/struktur-organisasi"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="struktural-bagan-button"
              className="mt-10 inline-flex items-center gap-3 rounded-full bg-[#1479BF] px-7 py-3.5 text-xs font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#0B2440]"
            >
              LIHAT BAGAN STRUKTUR PEJABAT LLDIKTI WILAYAH VII
            </a>
          </Reveal>
        </div>
      </main>
      <Footer compact />
    </div>
  );
}
